import { ConversationMessage } from "@/core/entities/conversation";
import { GetConversationMessagesParams, IConversationRepository } from "@/core/repositories/conversation";

export interface GetMessagesResponse {
  messages: ConversationMessage[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}
export class GetMessagesUseCase {
  constructor(private readonly conversationRepository: IConversationRepository) {}

  async execute(params: GetConversationMessagesParams, refetch: boolean = false): Promise<GetMessagesResponse> {
    const result = await this.conversationRepository.getConversationMessages(params, refetch);

    return {
      messages: result.messages.items.map(item => new ConversationMessage(item)),
      total: result.messages.total,
      page: result.messages.page,
      limit: result.messages.limit,
      hasMore: result.messages.hasMore,
    };
  }
}
